(function () {
  'use strict';

  /* Trust icons carousel runs on product pages regardless of card presence */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrustCarousel);
  } else {
    initTrustCarousel();
  }

  /* Run card-related code on any page that has product cards.
     The '.card-product__wrapper' selector catches all card layouts site-wide. */
  var CARD_SELECTORS = [
    '.productGrid',
    '.products-carousel',
    '.products-grid',
    '.products-flex',
    '.halo-product-block',
    '.halo-recently-viewed-block',
    '.recentlyViewed-row',
    '.card-product__wrapper'
  ];
  var pageHasCards = CARD_SELECTORS.some(function (s) {
    return document.querySelector(s);
  });
  if (!pageHasCards) return;

  var CART_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>';

  function setBtn(btn, state) {
    if (state === 'pressed') {
      btn.style.background = '#c9a84c';
      btn.style.transform  = 'scale(0.88)';
    } else {
      btn.style.background = '';
      btn.style.transform  = '';
    }
  }

  function injectButtons() {
    /* Target ALL card wrappers site-wide, not only those inside .productGrid */
    document.querySelectorAll('.card-product__wrapper').forEach(function (wrapper) {
      if (wrapper.querySelector('.mb-cart-icon-btn')) return;

      var btn = document.createElement('button');
      btn.className = 'mb-cart-icon-btn';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Add to cart');
      btn.innerHTML = CART_SVG;
      wrapper.appendChild(btn);

      var touchFired = false;

      btn.addEventListener('touchstart', function () {
        setBtn(btn, 'pressed');
      }, { passive: true });

      btn.addEventListener('touchend', function (e) {
        e.preventDefault();
        e.stopPropagation();
        touchFired = true;
        setBtn(btn, 'reset');
        addToCart(wrapper.closest('.product') || wrapper.closest('[class*="product-item"]'), btn);
      }, { passive: false });

      btn.addEventListener('mousedown', function () { setBtn(btn, 'pressed'); });
      btn.addEventListener('mouseup',   function () { setBtn(btn, 'reset'); });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (touchFired) { touchFired = false; return; }
        addToCart(wrapper.closest('.product') || wrapper.closest('[class*="product-item"]'), btn);
      });
    });
  }

  function addToCart(productEl, btn) {
    if (!productEl) return;
    var form  = productEl.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('input[name="id"]');
    if (!input || !input.value) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(input.value), quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.id) refreshCount();
      })
      .catch(function () {});
  }

  function refreshCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = String(c.item_count);
        ['.cart-count-bubble span[aria-hidden]', '.cart-item-count', '[data-cart-count]', '.cart-count']
          .forEach(function (sel) {
            document.querySelectorAll(sel).forEach(function (el) { el.textContent = n; });
          });
      })
      .catch(function () {});
  }

  injectButtons();

  /* Watch for dynamically injected product cards (recently viewed, infinite scroll, etc.) */
  var observer = new MutationObserver(function (mutations) {
    var needsInject = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('card-product__wrapper')) {
          needsInject = true;
        } else if (node.querySelector && node.querySelector('.card-product__wrapper')) {
          needsInject = true;
        }
      });
    });
    if (needsInject) injectButtons();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  /* ------------------------------------------------------------------ */
  /* Trust icons carousel — auto-scroll + left/right arrows (desktop)   */
  /* ------------------------------------------------------------------ */
  function initTrustCarousel() {
    var container = document.getElementById('container-mobile-new-home');
    if (!container) return;
    if (container.closest('.trust-icons-carousel-wrapper')) return; // already done

    var wrapper = document.createElement('div');
    wrapper.className = 'trust-icons-carousel-wrapper';
    container.parentNode.insertBefore(wrapper, container);
    wrapper.appendChild(container);

    var PREV_SVG = '<svg viewBox="0 0 24 24"><polyline points="15,18 9,12 15,6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var NEXT_SVG = '<svg viewBox="0 0 24 24"><polyline points="9,18 15,12 9,6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var prevBtn = document.createElement('button');
    prevBtn.className = 'trust-icons-arrow trust-prev';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.innerHTML = PREV_SVG;

    var nextBtn = document.createElement('button');
    nextBtn.className = 'trust-icons-arrow trust-next';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.innerHTML = NEXT_SVG;

    wrapper.insertBefore(prevBtn, container);
    wrapper.appendChild(nextBtn);

    /* Scroll by ~one box width + gap (computed from actual DOM) */
    function getStep() {
      var box = container.querySelector('.box');
      if (!box) return 96;
      var gap = parseFloat(window.getComputedStyle(container).gap) || 16;
      return box.offsetWidth + gap;
    }
    var autoTimer;

    function scrollNext() {
      var maxScroll = container.scrollWidth - container.clientWidth;
      if (container.scrollLeft >= maxScroll - 2) {
        container.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: getStep(), behavior: 'smooth' });
      }
    }

    function startAuto() {
      autoTimer = setInterval(scrollNext, 3000);
    }

    function resetAuto() {
      clearInterval(autoTimer);
      startAuto();
    }

    prevBtn.addEventListener('click', function () {
      container.scrollBy({ left: -getStep(), behavior: 'smooth' });
      resetAuto();
    });

    nextBtn.addEventListener('click', function () {
      container.scrollBy({ left: getStep(), behavior: 'smooth' });
      resetAuto();
    });

    startAuto();
  }

})();
